/* Circ header — mobile slide-in drawer with backdrop, scroll lock, Escape/backdrop close. */
(function () {
  const header = document.querySelector('sst-header');
  if (!header) return;

  const toggle = header.querySelector('.sst-header__toggle');
  const drawer = header.querySelector('.sst-header__drawer');
  const backdrop = header.querySelector('[data-sst-backdrop]');
  const closeButton = header.querySelector('[data-sst-drawer-close]');
  if (!toggle || !drawer || !backdrop) return;
  document.body.classList.remove('sst-menu-open');

  function openDrawer() {
    drawer.removeAttribute('hidden');
    backdrop.removeAttribute('hidden');
    document.body.classList.add('sst-menu-open');
    // next frame so transition runs
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      backdrop.classList.add('is-visible');
    });
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    backdrop.classList.remove('is-visible');
    document.body.classList.remove('sst-menu-open');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    window.setTimeout(function () {
      drawer.setAttribute('hidden', '');
      backdrop.setAttribute('hidden', '');
    }, 250);
  }

  toggle.addEventListener('click', function () {
    if (drawer.classList.contains('is-open')) {
      closeDrawer();
    } else {
      openDrawer();
    }
  });

  backdrop.addEventListener('click', closeDrawer);
  if (closeButton) {
    closeButton.addEventListener('click', closeDrawer);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  drawer.querySelectorAll('a').forEach(function (link) {
    link.addEventListener('click', closeDrawer);
  });

  // Drawer accordion: plus/minus toggle expands/collapses a parent's child
  // links in place. Buttons (not <a>), so the link-click closeDrawer above
  // doesn't fire for these.
  drawer.querySelectorAll('[data-sst-drawer-toggle]').forEach(function (toggleButton) {
    const submenu = toggleButton.closest('.sst-header__drawer-item').querySelector('.sst-header__drawer-submenu');
    if (!submenu) return;
    toggleButton.addEventListener('click', function () {
      const isOpen = toggleButton.getAttribute('aria-expanded') === 'true';
      toggleButton.setAttribute('aria-expanded', String(!isOpen));
      submenu.hidden = isOpen;
    });
  });
})();
